import type { PolicyStatus } from './PolicyTypes';

/** Resolved theme colors + label for a policy's verdict-derived status. */
export interface StatusVisual {
    label: string;
    solid: string;
    soft: string;
    border: string;
    text: string;
}

/** Status → colors: gray only when there's no data; green clear; amber flagged; red critical. */
export const STATUS_VISUAL: Record<PolicyStatus, StatusVisual> = {
    empty: {
        label: 'No data',
        solid: 'var(--bm-color-accent-neutral)',
        soft: 'var(--bm-color-accent-neutral-soft)',
        border: 'var(--bm-color-accent-neutral-border)',
        text: 'var(--bm-color-accent-neutral-text)',
    },
    clear: {
        label: 'Clear',
        solid: 'var(--bm-color-success)',
        soft: 'var(--bm-color-success-soft)',
        border: 'var(--bm-color-success-border)',
        text: 'var(--bm-color-success)',
    },
    flagged: {
        label: 'Flagged',
        solid: 'var(--bm-color-caution)',
        soft: 'var(--bm-color-caution-soft)',
        border: 'var(--bm-color-caution-border)',
        text: 'var(--bm-color-caution-text)',
    },
    critical: {
        label: 'Critical',
        solid: 'var(--bm-color-danger)',
        soft: 'var(--bm-color-danger-soft)',
        border: 'var(--bm-color-danger-border)',
        text: 'var(--bm-color-danger-text)',
    },
};
